import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import AuthTopBar from "../../../pages/authentication/component/AuthTopBar";
import CustomiseYourAIExperience from "./components/CustomiseYourAIExperience";
import ScaleYourAISolutions from "./components/ScaleYourAISolutions";
import { Toast } from "../../Toast/Toast";
import { useUserInfo } from "../../../context/user";
import { generateRandomID } from "../../../utils/generateRandomId";
import { useCreateAccountAndAddNewLocation } from "../../../queries/auth";
import BusinessDetails from "./components/BusinessDetails";
import { useUsersContext } from "../../../context/usersContext";

const AccountSetup = () => {
  const [type, setType] = useState("");
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const createAccountMutation = useCreateAccountAndAddNewLocation();
  const navigate = useNavigate();
  const location = useLocation();
  const templateData = location?.state?.templateData || null;
  const userActiveLocation = useUserInfo()[4];
  const userInfo = useUserInfo()[0];
  const updateUser = useUserInfo()[1];
  const setUserActiveLocation = useUserInfo()[3];
  const { products } = useUsersContext();
  const activePlan = products.filter(item => item.activePlan === true)[0];
  const [plan_id, setPlanId] = useState(
    userActiveLocation?.plan_id || userInfo?.plan_id || ""
  );
  const [inputs, setInputs] = useState({
    name: userInfo?.first_name || "",
    business_name: userActiveLocation?.business_name || templateData?.template_name || "",
    phone_number: userActiveLocation?.phone_number || "",
    team_size: userActiveLocation?.team_size || "",
    business_type: userActiveLocation?.business_type || "",
    customer_size: userActiveLocation?.customer_size || "",
  });

  const [toast, setToast] = useState({
    message: "",
    type: "error",
    isVisible: false,
    subMessage: "",
  });

  const onTypeClick = (type) => {
    setType(type);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const randomId = generateRandomID(20);
    const payload = {
      ...inputs,
      type: templateData ? "free" : userActiveLocation?.type,
      id: randomId,
      agency_id: userInfo?.agency_id || userActiveLocation?.agency_id,
      plan_id: plan_id,
      customer_id: userActiveLocation?.customer_id,
      stripe_cst_id: userActiveLocation?.stripe_cst_id,
      subscription_id: userActiveLocation?.subscription_id,
      assistants: userActiveLocation?.assistants || [],
      monthly_token_limit: userActiveLocation?.monthly_token_limit || activePlan?.token_limit || 0,
      number_of_additional_accounts: userActiveLocation?.number_of_additional_accounts,
      number_of_team_member:
        userActiveLocation?.number_of_team_member,
      number_of_tokens:
        userActiveLocation?.number_of_tokens,
      unlimited_ai_agents:
        userActiveLocation?.unlimited_ai_agents,
      number_of_ai_agents:

        userActiveLocation?.number_of_ai_agents,
      number_of_created_agents: userActiveLocation?.number_of_created_agents || 0,
      ...(templateData
        ? {
          free_account_template_id: templateData._id,
          promptlabels_ids: templateData.promptlabels_ids || [],
          apps: templateData.apps || ["Your AI"],
        }
        : {}),
    };
    setLoading(true);
    try {
      const { account: response, userUpdate } = await createAccountMutation.mutateAsync({
        payload,
        userId: userInfo.userId,
      });
      if (userUpdate?.success === true) {
        setUserActiveLocation(response?.data);
        updateUser(userUpdate?.data);
        navigate("/onboarding", {
          state: {
            accountDataLocation: response?.data?.id,
          },
        });
        setToast({
          message: "Account created successfully",
          type: "success",
          isVisible: true,
        });
      }
    } catch (error) {
      setToast({
        message: error.message,
        type: "error",
        subMessage: "Please try again",
        isVisible: true,
      });
    }
    setTimeout(
      () =>
        setToast({
          message: "",
          type: "error",
          subMessage: "",
          isVisible: false,
        }),
      3000
    );
    setLoading(false);
  };

  return (
    <div className="h-screen bg-background">
      <AuthTopBar />
      <div className="relative flex justify-center">
        <div className="text-center mt-14">
          {!type ? (
            <CustomiseYourAIExperience onTypeClick={onTypeClick} />
          ) : step === 0 ? (
            <ScaleYourAISolutions
              type={type}
              inputs={inputs}
              setInputs={setInputs}
              onNext={() => setStep(1)}
              onBack={() => setType("")}
            />
          ) : (
            <BusinessDetails
              inputs={inputs}
              setInputs={setInputs}
              loading={loading}
              handleSubmit={handleSubmit}
              onBack={() => setStep(0)}
            />
          )}
        </div>
      </div>
      <Toast
        duration={300}
        message={toast.message}
        subMessage={toast.subMessage ?? ""}
        type={toast.type}
        visible={toast.isVisible}
      />
    </div>
  );
};

export default AccountSetup;
